export const environment = {
  production: true,
  apiUrl: `https://tshua-ac.hagoyve-phone.com${(document.location.port ? `:${document.location.port}` : ``)}`
};


